export const matiesAmer = {
  maties_amer_configurations: `Configuraciones de Maties Amer`,
};
